module.exports = __webpack_public_path__ + "static/media/diamond.09737187.svg";